module.exports = __webpack_public_path__ + "img/1904_Kleine-Zeitung.9ce5b482.jpg";